import React, { useContext, useState } from 'react'
import Welcome from './Welcome';

import ViewEnquiry from './ViewEnquiries';

import SendFlashitem from './SendFlashdeal';
import ViewFlashdeals from './ViewFlashdeals';
import ViewOrders from './ViewOrders';
import { loginstatus } from '../../App';
import Login from './Login';
import ViewAccepted from './ViewAccepted';
import AddCategory from './AddCategory';


const Dashboard = () => {

  const [view, setView] = useState("");

  const [login, setLogin] = useContext(loginstatus)

  const dashboardView = () => {
    if (view === "") {
      return <Welcome setView={setView} />
    }
    else if (view === "AddItem") {
      return <SendFlashitem />
    }
    else if (view === "ViewItem") {
      return <ViewFlashdeals />
    }
    else if (view === "ViewOrders") {
      return <ViewOrders />
    }
    else if (view === "ViewAccepted") {
      return <ViewAccepted />
    }
    else if (view === "AddCategory") {
      return <AddCategory />
    }
    else if (view === "ViewEnquiry") {
      return <ViewEnquiry />
    }
    else {
      return <h4>Invalid View</h4>
    }
  }


  if (login) {
    return (
  <div className="container-fluid">
  <div className="row">

    {/* LEFT SIDE */}
    <div
      className="col-12 col-lg-4 p-3 p-lg-5 mt-3 mt-lg-5 text-center shadow border-end"
      style={{
        position: window.innerWidth >= 992 ? "sticky" : "static",
        top: 0,
        background: "#fff"
      }}
    >
      <h4 onClick={() => setView("")} className="shadow-lg  text-dark mb-3 p-5 ">
        Admin Dashboard
      </h4>

      <button onClick={() => setView("AddItem")} className="btn btn-light w-100 mb-3">
        Add Item
      </button>
      <button onClick={() => setView("ViewItem")} className="btn btn-light w-100 mb-3">
        View Items
      </button>
      <button onClick={() => setView("ViewOrders")} className="btn btn-light w-100 mb-3">
        Orders
      </button>
      <button onClick={() => setView("ViewAccepted")} className="btn btn-light w-100 mb-3">
        Accepted Orders
      </button>
      <button onClick={() => setView("AddCategory")} className="btn btn-light w-100 mb-3">
        Add Img Category
      </button>
      <button onClick={() => setView("ViewEnquiry")} className="btn btn-light w-100 mb-3">
        View Enquiries
      </button>
      <button onClick={() => setLogin(false)} className="btn btn-light w-100 mb-3">
        Logout
      </button>
    </div>

    {/* RIGHT SIDE */}
    <div className="col-12 col-lg-8 p-3 p-lg-5" style={{ overflowY: "auto" }}>
      {dashboardView()}
    </div>

  </div>
</div>
    )
  }
  else {
    return <Login />
  }

}

export default Dashboard